export const IOS_INVITE_URL = 'https://apps.apple.com/us/app/clero-pay-request-split/id6758653353';
export const ANDROID_INVITE_URL = 'https://play.google.com/store/apps/details?id=us.maini.clero.app';
